import { Skeleton } from "@mui/material";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { MuniSpinner2 } from "../../../../../components";
import { useGeneralAppStore } from "../../../../../store/generalAppStore";
import { useMonitoreoPersonalStore } from "../../../../../store/monitoreoPersonal";

import { useEffect, useState } from "react";
import useMonitoreoPersonal from "../../../../../api/monitoreoPersonal";
import { getMonitoreoUsuarioHandler, getPersonalMonitoreoHandler } from "../../../../../handlers/monitoreo.handler";
import { format, parseISO } from "date-fns";
import { Spinner } from "react-bootstrap";
import { es } from 'date-fns/locale';
import { useAbortController } from "../../../../../hooks/useAbortController";

const InteraccionesPersonal = () => {
  const { estadisticasGeneral, setEstadisticasGeneral, estadisticasPersona, setType, setFechaSeleccionada, fechaSeleccionada } = useMonitoreoPersonalStore();

  const signal = useAbortController()
  const fechaHoy = new Date()
  const hoyFormat = format(fechaHoy, 'yyyy-MM-dd')
  const [fechaSolicitada, setFechaSolicitada] = useState(fechaSeleccionada ?? hoyFormat);

  const { loads } = useGeneralAppStore();
  const { getEstadisticasGeneral } = useMonitoreoPersonal();
  const [fechaString, setFechaString] = useState();

  const [personalMonitoreo, setPersonalMonitoreo] = useState();

  const [dataFormateada, setDataFormateada] = useState()

  useEffect(() => {
    // if (estadisticasGeneral) setEstadisticasGeneral(null);

    if (!personalMonitoreo) {
      getPersonalMonitoreoHandler(setPersonalMonitoreo);
    }

    return () => {
      setEstadisticasGeneral(null)
    }
  }, []);



  useEffect(() => {
    if (!fechaSolicitada) return;

    if (fechaSolicitada) {
      const fechaObjeto = parseISO(fechaSolicitada);
      const fechaFormateada = format(fechaObjeto, "dd 'de' MMMM 'del' yyyy", { locale: es });
      setFechaString(fechaFormateada);
      setEstadisticasGeneral(null);


      getEstadisticasGeneral({
        fecha_solicitada: fechaSolicitada,
      }, signal);
    }
  }, [fechaSolicitada]);


  useEffect(() => {
    if (estadisticasGeneral) {
      const transformedData = estadisticasGeneral?.map(user => ({
        nombre: user.nombre,
        interacciones: user.interacciones,
        interacciones_backoffice: user.interacciones_backoffice,
      }));
      setDataFormateada(transformedData)
    }
  }, [])

  //! VERLOOOOOOOOOOOOOOO
  const coloresBarras = ["#8884d8", "#82ca9d", "#ffc658"]; // Colores personalizados

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div
          onClick={() => console.log(payload)}
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            padding: "10px",
            borderRadius: "5px",
            color: "#fff",
          }}>
          <p>{payload[0]?.payload.nombre}</p>
          <p style={{ color: payload[0]?.color }}>{payload[0]?.name}: {payload[0]?.value}</p>
          <p style={{ color: payload[1]?.color }}>{payload[1]?.name}: {payload[1]?.value}</p>
        </div>
      );
    }
    return null;
  };

  const CustomYAxisTick = ({ x, y, payload, data }) => {
    // Buscar la fila correspondiente en la data
    const rowData = data.find((item) => item.nombre === payload.value);

    return (
      <text
        x={x}
        y={y}
        dy={4}
        textAnchor="end"
        fill="#666"
        fontSize={14}
        fontWeight="bold"
        style={{ cursor: "pointer" }}
        onClick={() => {
          // setType('personal');
          getMonitoreoUsuarioHandler({ user_id: rowData?.user_id, fecha: fechaSolicitada }, setType);
          // console.log("Datos de la fila:", rowData);
        }}
      >
        {payload.value}
      </text>
    );
  };



  const handleSeleccionFecha = (e) => {
    // formato de fecha: yyyy-mm-dd (2025-12-31)
    setFechaSolicitada(e.target.value);
  };

  return (
    <>
      <div className="d-flex  position-relative">
        { 
        ['interacciones-personal-monitoreo', 'monitoreo_usuario'].some(key => loads.includes(key)) &&
        <div className="position-absolute d-flex w-100 h-100 justify-content-center align-items-center" style={{backgroundColor: loads.includes('monitoreo_usuario')  ? "rgba(255,255,255,0.8)" : "#fff", zIndex:"999"} }><MuniSpinner2/></div>
        }

        <section className="d-flex flex-column align-items-center flex-wrap pb-2 col mx-auto gap-4  mt-3 ">
          <section className=" d-flex flex-column  ">
            <label className="form-label m-0" htmlFor="fecha">
              Seleccione una fecha
            </label>
            <input
              defaultValue={fechaSeleccionada ?? hoyFormat}
              aria-describedby="fecha"
              aria-label="fecha"
              disabled={loads.includes("interacciones-personal-monitoreo")}
              id="fecha"
              type="date"
              className="form-control"
              onChange={(e) => {
                setFechaSolicitada(e.target.value);
                setFechaSeleccionada(e.target.value);
              }
              }
            />
          </section>

          <section className=" d-flex ">
            <div className="d-flex  flex-column gap-2  d-flex justify-content-start align-items-center">
              <h6 className=" m-0">Total interacciones</h6>
              {loads.includes("interacciones-personal-monitoreo") ? (
                <Spinner variant="primary" />
                // <Skeleton animation="wave" variant="rounded" width={15} height={19} />
              ) : (
                <h6 className="m-0 fs-3" style={{ color: "#1976D2" }}>
                  {estadisticasGeneral?.total_interacciones}
                </h6>
              )}
            </div>
          </section>

          {/* <section className=" d-flex ">
            <div className="d-flex  flex-column gap-1  d-flex justify-content-start align-items-center">
              <h6 className=" m-0">Fecha seleccionada</h6>

              <h6 className="m-0 fs-5" style={{ color: "#1976D2" }}>
                {fechaString}
              </h6>
            </div>
          </section> */}
        </section>
        <section>

          <div style={{ height: "905px", minWidth: "80vw" }}>
            {
              estadisticasGeneral?.interacciones_por_usuario &&

              <ResponsiveContainer width="100%" height={"100%"} className={'mx-auto'}>
                <BarChart
                  layout="vertical"
                  width={500}
                  height={200}
                  // data={data}
                  data={estadisticasGeneral?.interacciones_por_usuario}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
                  <XAxis type="number" tick={{ fill: '#333', fontSize: 16, fontWeight: "bold" }} />
                  <YAxis
                    dataKey="nombre" type="category"
                    tick={(props) => <CustomYAxisTick {...props} data={estadisticasGeneral?.interacciones_por_usuario} />}
                    width={100}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend verticalAlign="top" align="center" wrapperStyle={{ fontSize: '14px', fontWeight: "bold" }} />
                  <Bar dataKey="interacciones" barSize={15} name="Interacciones" fill={coloresBarras[0]} />
                  <Bar dataKey="interacciones_backoffice" barSize={15} name="Interacciones Backoffice" fill={coloresBarras[1]} />
                </BarChart>
              </ResponsiveContainer>
            }
          </div>
        </section>
      </div>
    </>
  );
};
export default InteraccionesPersonal;
